import React, { useMemo } from 'react';
import ContentGridView from './ContentGridView';

// Renders Instagram + Twitter posts grouped by platform. Mirrors VideoBySectionView's
// shape so the editor's UX is consistent across sections.
const SocialMediaBySectionView = ({ content, reportId, excludedContentIds = [], onContentExcluded, sortBy = 'views-high', onSortChange }) => {
  const groupedByPlatform = useMemo(() => {
    const groups = {};
    const filteredContent = content.filter(post => !excludedContentIds.includes(post.id));

    filteredContent.forEach(post => {
      const platform = (post.platform || 'other').toLowerCase();
      if (!groups[platform]) groups[platform] = [];
      groups[platform].push(post);
    });

    return groups;
  }, [content, excludedContentIds]);

  const platformOrder = ['instagram', 'twitter'];
  const platformLabels = {
    instagram: 'Instagram Posts',
    twitter: 'Twitter Posts'
  };

  const platformsToShow = platformOrder.filter(p => groupedByPlatform[p]?.length > 0);

  return (
    <div className="space-y-6">
      {platformsToShow.map(platform => (
        <div key={platform} className="space-y-2">
          <div className="flex items-center justify-between bg-gray-900 px-4 py-2 rounded-lg border border-white">
            <h3 className="text-sm font-semibold text-white">
              {platformLabels[platform] || `${platform.charAt(0).toUpperCase() + platform.slice(1)} Posts`}
            </h3>
            <span className="text-xs font-medium text-white bg-white/10 px-2 py-1 rounded">
              {groupedByPlatform[platform].length} post{groupedByPlatform[platform].length !== 1 ? 's' : ''}
            </span>
          </div>

          <ContentGridView
            content={groupedByPlatform[platform]}
            reportId={reportId}
            excludedContentIds={excludedContentIds}
            onContentExcluded={onContentExcluded}
            sortBy={sortBy}
            onSortChange={onSortChange}
          />
        </div>
      ))}
    </div>
  );
};

export default SocialMediaBySectionView;
